module.exports = __webpack_public_path__ + "img/logo-genl.61b8f0c7.webp";